import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { Toggle } from "pepsico-ds";
import { useEffect } from "react";
import "../switchField/toggleStyles.scss";

const WinnerOnlyToggleComponent = (props) => {
  const { handleChange, label, data: fieldData, path, uischema, enabled } = props;

  // Get the complete form data from context
  const jsonFormsContext = useJsonForms();
  const formData = jsonFormsContext?.core?.data || {};
  const isInverted = uischema?.options?.isInverted || false;

  const updateValue = (val) => {
    handleChange(path, isInverted ? !val : val);
  };

  // Check if campaignId exists in the form data
  const hasCampaignId = formData && formData.campaignId;

  // Toggle should be disabled if no campaignId is selected
  const isDisabled = !enabled || !hasCampaignId;

  // Remove the value from form data when there's no campaign ID
  useEffect(() => {
    if (!hasCampaignId && fieldData !== undefined) {
      handleChange(path, undefined);
    }
  }, [hasCampaignId, fieldData, handleChange, path]);

  return (
    <Toggle
      className="toggleStyles"
      label={uischema?.rightLabelComponent ? "" : label}
      onUpdate={updateValue}
      size={uischema.size || "medium"}
      checked={isInverted ? !fieldData : fieldData}
      value={uischema?.rightLabelComponent ?? ""}
      disabled={isDisabled}
    />
  );
};

export const WinnerOnlyToggleControl = withJsonFormsControlProps(
  WinnerOnlyToggleComponent
);
